<iframe #frame title="Acompanhamento Receita" src="https://app.powerbi.com/view?r=eyJrIjoiNWUwZDVlMDctZDE0MS00MmIxLWE3MjctNGJlYjFiMTdiNzVhIiwidCI6ImZkOTliM2EzLWUzODctNGE1MC05NTRhLTUzMDc5NGY5NWYwMCJ9" allowFullScreen="true"></iframe>
